export default function textValidator(input, allowTwoWords = false) {
    if (typeof input !== "string") return false;

    // Trim extra spaces
    input = input.trim();

    // Allow only a single word (for Last Name)
    if (!allowTwoWords) {
        return /^[A-Za-z]+$/.test(input); // Matches only letters
    }

    // Allow up to two words (for First Name)
    return /^[A-Za-z]+(?:\s[A-Za-z]+)?$/.test(input);
}
